const USER_PROFILES = [
  {
    primaryEmail: 'ramish.mohammed@nugrant.com',
    aliases: ['admin@nugrant.com'],
    firstName: 'Ramish',
    lastName: 'Mohammed',
  },
  {
    primaryEmail: 'adminreviewer@nugrant.com',
    aliases: [],
    firstName: 'Sagar',
    lastName: 'Chohan',
  },
  {
    primaryEmail: 'jessica.costa@nugrant.com',
    aliases: ['admintestuser@nugrant.com'],
    firstName: 'Jessica',
    lastName: 'Costa',
  },
  {
    primaryEmail: 'anushka.jain@nugrant.com',
    aliases: ['manager@nugrant.com'],
    firstName: 'Anushka',
    lastName: 'Jain',
  },
  {
    primaryEmail: 'lawrence.abeyta@nugrant.com',
    aliases: ['reviewer@nugrant.com'],
    firstName: 'Lawrence',
    lastName: 'Abeyta',
  },
  {
    primaryEmail: 'adil.asad@nugrant.com',
    aliases: [],
    firstName: 'Adil',
    lastName: 'Asad',
  },
  {
    primaryEmail: 'vineet.sharma@nugrant.com',
    aliases: [],
    firstName: 'Vineet',
    lastName: 'Sharma',
  },
];

function normalizeEmail(email = '') {
  return String(email || '').trim().toLowerCase();
}

function findProfile(email = '') {
  const normalizedEmail = normalizeEmail(email);
  if (!normalizedEmail) return null;

  return (
    USER_PROFILES.find((profile) => (
      profile.primaryEmail === normalizedEmail
      || (profile.aliases || []).includes(normalizedEmail)
    )) || null
  );
}

export function buildFullName(firstName = '', lastName = '') {
  return [String(firstName || '').trim(), String(lastName || '').trim()].filter(Boolean).join(' ').trim();
}

export function getDefaultNamePartsForEmail(email = '') {
  const profile = findProfile(email);
  return profile ? { firstName: profile.firstName, lastName: profile.lastName } : null;
}

export function getCanonicalEmail(email = '') {
  const normalizedEmail = normalizeEmail(email);
  const profile = findProfile(normalizedEmail);
  return profile?.primaryEmail || normalizedEmail;
}

export function getDisplayName(user = {}) {
  const email = normalizeEmail(user?.email || '');
  const profile = findProfile(email);
  const firstName = String(user?.firstName || profile?.firstName || '').trim();
  const lastName = String(user?.lastName || profile?.lastName || '').trim();
  return buildFullName(firstName, lastName) || String(user?.fullName || '').trim() || getCanonicalEmail(email) || 'User';
}
